module.exports = __webpack_public_path__ + "img/db_2.f1f707d6.svg";